<template >
    <div class="container-fluid" v-if="question">

      <div class="row">
        <div class="col-lg-12">
          <div class="card shadow mb-4">
            <div class="card-header">
              <div class="row">
                <div class="col"><h4>Асуулт</h4></div>
                <div class="col col-auto">
                  
                  <i class="fas fa-edit mr-3" style="cursor:pointer" @click="editQuestion(question, cat)"></i>
                  <router-link :to="{ name: 'ImageAdd', params: { objectPath: 'lessons/'+lessonId+'/topics/'+ topicId+'/details/'+contentId+'/tests/'+categoryId+'/questions/'+question.id}}">Зураг оруулаx</router-link>
                </div>
              </div>
            </div>
            <div class="card-body">

              <div class="my-2" v-if='question.tags!=null && question.tags.length>0'>
                <label>Түлхүүр үгс: </label>
                <span class="badge badge-pill badge-success mr-2" v-for="(tag, ti) in question.tags">
                  {{tag}}
                </span>
              </div>
              <div class="row  text-center text-lg-left" v-if="question.images!=null && question.images.length>0">
                  <div class="col-lg-3 col-md-4 col-6" v-for="(file, index) in question.images" v-bind:key="file.fileUrl">
                      <a href="#" class="d-block mb-4 h-100">
                      <img class="img-fluid img-thumbnail" :src="file.fileUrl" @click="deleteFile(file, index)"/>
                      </a>
                  </div>
              </div>
              <div class="card mb-4" v-for="(subquestion, index) in question.subquestions" v-bind:key="subquestion.id">
                  <div class="card-header py-3">
                    <h4 class="row">
                      <span class="col">
                        <!-- {{subquestion.title}} -->
                        <span v-if="isLatex(subquestion.title)==true">
                          <vue-mathjax :formula="getLatexText(subquestion.title)"></vue-mathjax>
                        </span>
                        <span v-else>{{subquestion.title}}</span>
                      </span> 
                      <span class="col-auto badge badge-info">{{subquestion.score}} оноо</span>
                    </h4>
                    <hr/>
                    <p v-if="subquestion.solution!=null && subquestion.solution!=''">
                      <span class="h6">Асуултын шийдэл:  </span>
                      <span v-if="isLatex(subquestion.solution)==true">
                        <vue-mathjax :formula="getLatexText(subquestion.solution)"></vue-mathjax>
                      </span>
                      <span v-else>{{subquestion.solution}}</span>
                    </p>
                    
                    <p v-if="subquestion.videoUrl!=null && subquestion.videoUrl!=''">
                      <span class="h6">Асуултын шийдэл видео:  </span>
                      <a v-bind:href="subquestion.videoUrl" target="blank">Видео үзэх</a>
                    </p>
                    
                    <p>
                      <span v-if="isLatex(subquestion.description)==true">
                        <vue-mathjax :formula="getLatexText(subquestion.description)"></vue-mathjax>
                      </span>
                      <span v-else>{{subquestion.description}}</span>
                      <!-- {{subquestion.description}} -->

                    </p>
                    <p>
                      <span v-if="isLatex(question.description)==true">
                        <vue-mathjax :formula="getLatexText(question.description)"></vue-mathjax>
                      </span>
                      <span v-else>{{question.description}}</span>
                      <!-- {{subquestion.description}} -->

                    </p>
                    <div v-if="subquestion.answertype==true">
                      <div class="panel panel-primary" id="result_panel" v-if="subquestion.useranswers!=null && subquestion.useranswers.length>0">
              
                        <div class="panel-body">
                            <ul class="list-group">
                                <li class="list-group-item" v-for="(answer, index) in subquestion.useranswers" v-if="answer!=null && answer.answer!=null && answer.answer!='Хариулт байхгүй'">
                                  <strong>{{index+1}}.</strong> {{answer.answer}}
                                </li>
                            </ul>
                        </div>
                      </div>
                      
                    </div>

                    <div v-else>
                      <div class="row" v-if="subquestion.answers!=null && subquestion.answers.length>0">
                        <div class="col-lg-6 mb-4">

                          <ul class="list-group">
                            <li
                              v-for="(answer, index) in subquestion.answers"
                              v-bind:key="answer.id"
                              class="list-group-item"
                            >
                              <div class="row">
                                <div class="col col-10">
                                  <span class="font-weight-bold">{{index+1}}. &nbsp;</span>
                                   <!-- {{answer.name}} -->
                                  <span v-if="isLatex(answer.name)==true">
                                    <vue-mathjax :formula="getLatexText(answer.name)"></vue-mathjax>
                                  </span>
                                  <span v-else>{{answer.name}}</span>
                              </div>
                                <div class="col col-2">
                                  <span v-if="answer.correct" class="badge badge-success badge-pill">зөв</span>
                                  <span v-else class="badge badge-danger badge-pill">буруу</span>
                                  &nbsp;&nbsp;
                                  <span class="badge badge-primary badge-pill">{{answer.votedCount}}</span>
                                </div>
                              </div>
                            </li>
                          </ul>
                        </div>

                        <div class="col-lg-6 mb-4">
                          <div class="post" v-if="subquestion.statData!=null && subquestion.datacollection">
                            <bar-chart :chartData="subquestion.datacollection" :options="options"></bar-chart>

                            <!-- <apexcharts  type="bar" :options="statData.chartOptions" :series="statData.series"></apexcharts> -->
                          </div>
                          <div v-else class="alert alert-success">Одоогоор энэ асуултанд хүн хариулаагүй байна.</div>
                        </div>
                      </div>

                      <div v-else class="alert alert-success">Одоогоор энэ асуултанд хариулт оруулаагүй байна.</div>
                    </div>
                  </div>

                </div>


              
            </div>
          </div>
        </div>

      </div>

      <hr class="mb-5"/>

    </div>
    
</template>

<script>
const fb = require('../../firebaseConfig.js')
import { mapState } from 'vuex'
import moment from 'moment'
import firebase from 'firebase'
import BarChart from "../BarChart.js";
import {VueMathjax} from 'vue-mathjax'
import latexmixin from '../global/latex.js';
var colors=[
  "#00E396",
  "#FEB019",
  "#FF4560",
  "#775DD0",
  "#546E7A",
  "#26a69a",
  "#D10CE8"
];
export default {
    name: "QuestionDetail",
    components: {
      'bar-chart': BarChart,
      'vue-mathjax': VueMathjax
    },
    mixins: [latexmixin],
    data() {
        return {
            item:null,
            category:null,
            question:null,
            statData: {
              chartOptions: {
                chart: {
                  id: "basic-bar"
                },
                colors: colors,
                labels: {
                  show: true,
                  hideOverlappingLabels: false
                },
                plotOptions: {
                  bar: {
                    distributed: true,
                    horizontal: true,
                    endingShape: "rounded"
                  }
                }
                // plotOptions: {
                //     bar: {
                //     horizontal: false,
                //     columnWidth: '55%',
                //     endingShape: 'rounded'
                //     },
                // },
              },
              series: [
                {
                  name: "series-1",
                  data: [
                    {
                      x: "Apple",
                      y: 54
                    },
                    {
                      x: "Orange",
                      y: 66
                    }
                  ]
                }
              ]
            }
            
        };
    },
    methods: {
      editQuestion(question) {


          if(question.simple==true)
            this.$router.push({ name: "SimpleQuestionAdd", params: { questionId: question.id, categoryId:this.categoryId, detailPath: "lessons/" + this.lessonId + "/topics/"+this.topicId+"/details/"+this.contentId} });
          else
            this.$router.push({ name: "DetailQuestionAdd", params: { questionId: question.id, categoryId:this.categoryId, detailPath: "lessons/" + this.lessonId + "/topics/"+this.topicId+"/details/"+this.contentId} });
        
      },
        
      _getQA(){
        fb.db.doc("lessons/"+this.lessonId+"/topics/"+this.topicId+"/details/"+this.contentId+"/tests/"+this.categoryId+"/questions/"+this.questionId).get().then(qDoc=>{
          let question=qDoc.data();
          question.id=qDoc.id;
          question.subquestions=[];
          
          
          qDoc.ref.collection("subquestions").get().then(sdocs=>{
            
            sdocs.forEach((sub)=>{
              if(sub.exists){
                let subquestion=sub.data();
                subquestion.id=sub.id;
                subquestion.answers=[];
                sub.ref.collection("answers").get().then(adocs=>{
            
           
                      let labels = [];
                      let dataset = [
                        {
                          label: "A",
                          backgroundColor: "#f87979",
                          data: [],
                          backgroundColor: []
                        }
                      ];
                      let data = [];
                      let index = 0;
                      let answered = false;
                      adocs.forEach(doc => {
                        let answer = doc.data();
                        answer.id = doc.id;
                        if (answer.votedCount != null && answer.votedCount > 0)
                          answered = true;
                        labels.push(answer.name);
                        dataset[0].data.push(answer.votedCount);
                        dataset[0].backgroundColor.push(
                          index <= colors.length ? colors[index] : this.getRandomColor()
                        );
                        data.push({
                          x: answer.name,
                          y: answer.votedCount,
                          color: this.getRandomColor()
                        });

                        subquestion.answers.push(answer);
                        index++;
                      });
                      if (answered == true) {
                        subquestion.statData = this.statData;
                        subquestion.datacollection = {
                          labels: labels,
                          datasets: dataset
                        };
                        // this.statData.chartOptions.xaxis.categories=labels
                        subquestion.statData.series = [
                          {
                            name: "санал",
                            data: data
                          }
                        ];
                      } 
                      else {
                        subquestion.datacollection = null;
                        subquestion.statData = null;
                      }
                  });

                question.subquestions.push(subquestion);
              }
            });
          });
          this.question=question;
        });
  

      },


      setPropContent(value,topic, item, propertyName){
        if(this.lesson!=null && topic!=null && item!=null && propertyName!=null)
          this.setProperty(propertyName, fb.db.doc("lessons/"+this.lesson.id+"/topics/"+topic.id+"/details/"+item.id), value);
      },
      setProperty(propertyName, object, value){
        if(object!=null && propertyName!=null){
          var tmp={};
          tmp[propertyName]=value;
          object.update(tmp);
        }
      },
      getRandomColor() {
        var letters = "0123456789ABCDEF";
        var color = "#";
        for (var i = 0; i < 6; i++) {
          color += letters[Math.floor(Math.random() * 16)];
        }
        return color;
      },

      getType(type){
        if(type=="test")
          return "Тест";
        else if(type=="video")
          return "Видео хичээл";
        else if(type=="lecture")
          return "Лекц";
        else if(type=="seminar")
          return "Семинар";
        else if(type=="exam")
          return "Шалгалт";
        else if(type=="homework")
          return "Гэрийн даалгавар";
        else if(type=="coursework")
          return "Бие даалт";
        
      }
    },
    computed: {
        ...mapState(['userProfile', 'currentUser'])
    },
    props: {
        lessonId: { 
            required: true,
        },
        topicId: { 
            required: true,
        },
        contentId: { 
            required: true,
        },
        categoryId: { 
            required: true,
        },
        questionId: { 
            required: true,
        }, 
    },
    created() {
        var _this=this;
        if(this.questionId!=null && this.questionId!='')
          this._getQA();
            
    },
    filters: {
		  formatDate(val) {
          if (!val) { return '-' }
          let date = val.toDate()
          return moment(date).format('MM/DD/YYYY HH:mm');
      },
    }
  
};
</script>

